import { styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller, useFormContext } from "react-hook-form";
import { retrieveFieldError } from "../../utils/formHelpers";
import FormField from "./FormField";
import { useTranslation } from "react-i18next";

export const CustomDatePicker = styled(DatePicker)({
  "& .MuiPickersInputBase-root": {
    height: 40,
    boxSizing: "border-box",
    borderWidth: "1px",
    borderRadius: 4,
    border: "none !important",
    boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.2)",
  },
});

export default function DateField(props) {
  const {
    name,
    label,
    hint,
    required = false,
    disabled = false,
    minDate,
    maxDate,
    labelSx,
    ...rest
  } = props;

  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = retrieveFieldError(name, errors);

  return (
    <FormField
      label={label}
      hint={hint}
      error={errorMessage}
      disabled={disabled}
      required={required}
      labelSx={labelSx}
    >
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? t("frontend.labels.validation.required") : false,
        }}
        render={({ field: { onChange, value } }) => (
          <CustomDatePicker
            {...rest}
            value={value || null}
            onChange={(date) => {
              onChange(date);
            }}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            slotProps={{ textField: { variant: "outlined" } }}
          />
        )}
      />
    </FormField>
  );
}
